module.exports = __webpack_public_path__ + "static/media/SZ.6e224dc9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/SZ.svg
// module id = 2269
// module chunks = 7